import JiraAttachment from "../api/model/integrations/barrel/JiraAttachment";
import { JIRA_ATL_ORIGIN_TOKEN } from "../constants";
import { groupBy } from "./array";

export type RelatedJiraAttachmentItem = Pick<JiraAttachment, "deploymentUrl" | "issueKey" | "details"> & { href: string; };

export function getJiraAttachmentsLink(attachments: JiraAttachment[]) {
    let baseHref = "";
    let jqlPart = "";

    attachments.forEach(({ issueUrl, issueKey }, index) => {
        if (index === 0) {
            baseHref = issueUrl;
            jqlPart += `jql=issuekey in (${issueKey}`;
        } else {
            jqlPart += `,${issueKey}`;
        }
    });

    jqlPart += ")";

    return attachments.length > 1 ? `${baseHref}?${jqlPart}` : baseHref;
}

export function getRelatedJiraAttachments(
    attachments: JiraAttachment[],
    { itemType, itemId }: { itemType: string; itemId: string; }
): RelatedJiraAttachmentItem[] {
    if (!attachments) {
        return [];
    }

    const groupedAttachments = groupBy(attachments
        .filter(attachment => (attachment.type === itemType && attachment.itemId === itemId)), "deploymentUrl");

    const atlOrigin = `atlOrigin=${JIRA_ATL_ORIGIN_TOKEN}`;
    return Object.values(groupedAttachments).reduce((acc, currAttachments) => {
        currAttachments.forEach(attachment => {
            const baseHref = attachment.issueUrl;
            acc.push({
                deploymentUrl: attachment.deploymentUrl,
                issueKey: attachment.issueKey,
                details: attachment.details,
                href: `${baseHref}?${atlOrigin}`
            });
        });
        return acc;
    }, [] as RelatedJiraAttachmentItem[]);
}
